import { render, staticRenderFns } from "./EditPostDropZone.vue?vue&type=template&id=b24c5a1e&scoped=true&"
import script from "./EditPostDropZone.vue?vue&type=script&lang=ts&"
export * from "./EditPostDropZone.vue?vue&type=script&lang=ts&"
import style0 from "./EditPostDropZone.vue?vue&type=style&index=0&id=b24c5a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24c5a1e",
  null
  
)

export default component.exports